import { useState, useRef, useEffect } from "react";

export function useCanvasPause(rootMargin = "100px") {
  const sectionRef = useRef(null);
  const [frameloop, setFrameloop] = useState("never");

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        setFrameloop(entry.isIntersecting ? "always" : "never");
      },
      { rootMargin },
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [rootMargin]);

  return { sectionRef, frameloop };
}
